"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokStatsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Stats Items */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Stats Items</h4>
            <ListItemEditor
              label="Stats"
              items={content.stats || [
                { value: "259k", label: "TOTAL ITEMS", image: "/assets/img/icon/counter_1_1.svg" },
                { value: "152k", label: "SOLD ITEMS", image: "/assets/img/icon/counter_1_2.svg" },
                { value: "580", label: "PENDING ITEMS", image: "/assets/img/icon/counter_1_3.svg" },
                { value: "39k+", label: "HAPPY CLIENTS", image: "/assets/img/icon/counter_1_4.svg" },
              ]}
              itemSchema={[
                { key: "value", label: "Value", type: "text" },
                { key: "label", label: "Label", type: "text" },
                { key: "image", label: "Image / Icon", type: "image" },
              ]}
              onChange={(items) => handleChange({ ...content, stats: items })}
              addItemText="Add Stat"
            />
          </div>

          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Our Achievements"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Our Numbers Speak For Us"
            />
          </div>
        </>
      }
    />
  );
}
